export default __webpack_public_path__ + "static/warning-messages-awareness-do-b9819748417840400f7dbb65c4052373.png";